var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('base-header',[_c('div',{attrs:{"slot":"page-header"},slot:"page-header"},[_vm._v("Page Empty")])])],1),_c('v-row',[_c('div',{staticStyle:{"height":"750px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }